import { render, staticRenderFns } from "./DialogWebDocuments.vue?vue&type=template&id=06a572e4&"
import script from "./DialogWebDocuments.vue?vue&type=script&lang=js&"
export * from "./DialogWebDocuments.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports